import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAverageSwingSpeedBackground = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 173,
	height: 206.148,
	viewBox: "0 0 173 206.148",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "Path_2152",
				x: 53.295,
				y: 12.204,
				width: 34.242,
				height: 57.296,
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feOffset", {
						dy: 3,
						input: "SourceAlpha"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 3,
						result: "blur"
					}),
					/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
					/* @__PURE__ */ _jsx("feComposite", {
						operator: "in",
						in2: "blur"
					}),
					/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "Path_2152-2",
				x: 53.295,
				y: 101.5,
				width: 34.242,
				height: 57.296,
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feOffset", {
						dy: 3,
						input: "SourceAlpha"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 3,
						result: "blur-2"
					}),
					/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
					/* @__PURE__ */ _jsx("feComposite", {
						operator: "in",
						in2: "blur-2"
					}),
					/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "Path_2153",
				x: 102.796,
				y: 62.204,
				width: 34.242,
				height: 57.296,
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feOffset", {
						dy: 3,
						input: "SourceAlpha"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 3,
						result: "blur-3"
					}),
					/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
					/* @__PURE__ */ _jsx("feComposite", {
						operator: "in",
						in2: "blur-3"
					}),
					/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "Path_2153-2",
				x: 100.925,
				y: 148.853,
				width: 34.242,
				height: 57.296,
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feOffset", {
						dy: 3,
						input: "SourceAlpha"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 3,
						result: "blur-4"
					}),
					/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
					/* @__PURE__ */ _jsx("feComposite", {
						operator: "in",
						in2: "blur-4"
					}),
					/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
				]
			})
		] }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_2643",
			"data-name": "Group 2643",
			transform: "translate(-865 -443)",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "Path_194",
					"data-name": "Path 194",
					transform: "translate(865 443)",
					fill: "#58595b",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M 37.5 14.5 L 7.5 14.5 C 3.64018988609314 14.5 0.5 11.35980987548828 0.5 7.5 C 0.5 3.64018988609314 3.64018988609314 0.5 7.5 0.5 L 37.5 0.5 C 41.35980987548828 0.5 44.5 3.64018988609314 44.5 7.5 C 44.5 11.35980987548828 41.35980987548828 14.5 37.5 14.5 Z",
						stroke: "none"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M 7.5 1 C 3.915889739990234 1 1 3.915889739990234 1 7.5 C 1 11.08411026000977 3.915889739990234 14 7.5 14 L 37.5 14 C 41.08411026000977 14 44 11.08411026000977 44 7.5 C 44 3.915889739990234 41.08411026000977 1 37.5 1 L 7.5 1 M 7.5 0 L 37.5 0 C 41.64212799072266 0 45 3.35785961151123 45 7.5 C 45 11.64213943481445 41.64212799072266 15 37.5 15 L 7.5 15 C 3.357860565185547 15 0 11.64213943481445 0 7.5 C 0 3.35785961151123 3.357860565185547 0 7.5 0 Z",
						stroke: "none",
						fill: "#707070"
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Path_197",
					"data-name": "Path 197",
					transform: "translate(993 443)",
					fill: "#58595b",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M 37.5 14.5 L 7.5 14.5 C 3.64018988609314 14.5 0.5 11.35980987548828 0.5 7.5 C 0.5 3.64018988609314 3.64018988609314 0.5 7.5 0.5 L 37.5 0.5 C 41.35980987548828 0.5 44.5 3.64018988609314 44.5 7.5 C 44.5 11.35980987548828 41.35980987548828 14.5 37.5 14.5 Z",
						stroke: "none"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M 7.5 1 C 3.915889739990234 1 1 3.915889739990234 1 7.5 C 1 11.08411026000977 3.915889739990234 14 7.5 14 L 37.5 14 C 41.08411026000977 14 44 11.08411026000977 44 7.5 C 44 3.915889739990234 41.08411026000977 1 37.5 1 L 7.5 1 M 7.5 0 L 37.5 0 C 41.64212799072266 0 45 3.35785961151123 45 7.5 C 45 11.64213943481445 41.64212799072266 15 37.5 15 L 7.5 15 C 3.357860565185547 15 0 11.64213943481445 0 7.5 C 0 3.35785961151123 3.357860565185547 0 7.5 0 Z",
						stroke: "none",
						fill: "#707070"
					})]
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_195",
					"data-name": "Path 195",
					d: "M.846,0H5.31V-.99H2.016V-6.3H.846ZM10.6-2.376A2.344,2.344,0,0,0,8.172-4.86,2.39,2.39,0,0,0,5.688-2.4,2.44,2.44,0,0,0,8.343.063,2.436,2.436,0,0,0,10.278-.72l-.6-.693A1.722,1.722,0,0,1,8.37-.891,1.455,1.455,0,0,1,6.813-2.043h3.771C10.593-2.151,10.6-2.286,10.6-2.376ZM8.172-3.96A1.308,1.308,0,0,1,9.531-2.79H6.8A1.328,1.328,0,0,1,8.172-3.96Zm5.463-1.872a1.108,1.108,0,0,1,.621.2l.315-.846a1.8,1.8,0,0,0-1.017-.261,1.553,1.553,0,0,0-1.719,1.665v.306h-.792v.9h.792V0H12.96V-3.87h1.287v-.9H12.924v-.288C12.924-5.571,13.167-5.832,13.635-5.832Zm3.942,4.77a1.012,1.012,0,0,1-.63.2c-.432,0-.666-.252-.666-.72V-3.87h1.287v-.9H16.281v-1.1H15.156v1.1h-.792v.9h.792v2.313A1.477,1.477,0,0,0,16.812.063a1.768,1.768,0,0,0,1.08-.324Z",
					transform: "translate(878 453)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_198",
					"data-name": "Path 198",
					d: "M6.228,0,4.779-2.07A2.014,2.014,0,0,0,6.12-4.059C6.12-5.454,5.094-6.3,3.438-6.3H.846V0h1.17V-1.836H3.438a2.193,2.193,0,0,0,.243-.009L4.968,0ZM4.941-4.059c0,.792-.531,1.26-1.557,1.26H2.016V-5.31H3.384C4.41-5.31,4.941-4.851,4.941-4.059ZM7.884-5.6a.691.691,0,0,0,.72-.7.67.67,0,0,0-.72-.648.685.685,0,0,0-.72.675A.685.685,0,0,0,7.884-5.6ZM7.317,0H8.442V-4.806H7.317Zm6.3-4.806v.639a2.081,2.081,0,0,0-1.665-.693,2.282,2.282,0,0,0-2.43,2.313,2.3,2.3,0,0,0,2.43,2.331,2.116,2.116,0,0,0,1.611-.639V-.6c0,.972-.468,1.458-1.53,1.458A2.9,2.9,0,0,1,10.26.279l-.5.846a3.82,3.82,0,0,0,2.34.684A2.264,2.264,0,0,0,14.688-.729V-4.806ZM12.123-1.17a1.363,1.363,0,0,1-1.467-1.377,1.354,1.354,0,0,1,1.467-1.359,1.351,1.351,0,0,1,1.458,1.359A1.36,1.36,0,0,1,12.123-1.17Zm6.768-3.69a2.142,2.142,0,0,0-1.6.612v-2.43H16.164V0h1.125V-2.43A1.276,1.276,0,0,1,18.63-3.879c.72,0,1.143.414,1.143,1.269V0H20.9V-2.754A1.878,1.878,0,0,0,18.891-4.86Zm6.012,3.8a1.012,1.012,0,0,1-.63.2c-.432,0-.666-.252-.666-.72V-3.87h1.287v-.9H23.607v-1.1H22.482v1.1H21.69v.9h.792v2.313A1.477,1.477,0,0,0,24.138.063a1.768,1.768,0,0,0,1.08-.324Z",
					transform: "translate(1005 453)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_196",
					"data-name": "Path 196",
					d: "M0,0V134",
					transform: "translate(960.167 483.5)",
					fill: "none",
					stroke: "#707070",
					strokeLinecap: "round",
					strokeWidth: 1,
					strokeDasharray: "1 2"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgAverageSwingSpeedBackground);
export { ForwardRef as ReactComponent };
